import { AnyAction } from 'redux';
import { Map } from 'immutable';
import { State } from '~/types/redux/todo';
import { ImmutableMap, TypedMap } from '~/utils/typedImmutable';

export const defaultState = TypedMap<State>({
  contacts: Map(),
  updates: Map(),
  note: '',
  assignee: null,
  greets: Map(),
});

export default function reducer(
  state: ImmutableMap<State>,
  action: AnyAction
): ImmutableMap<State> {
  switch (action.type) {
    case 'addGreet':
      return state.setIn(['greets', action.payload.key], action.payload.data);
    case 'removeGreet':
      return state.deleteIn(['greets', action.payload.key]);
    case 'selectContact':
      return state.setIn(['contacts', action.payload.key], action.payload);
    case 'deselectContact':
      return state.deleteIn(['contacts', action.payload.key]);
    case 'updateContact':
      return state.setIn(
        ['updates', action.payload.key, action.payload.column],
        action.payload.value
      );
    case 'updateNote':
      return state.set('note', action.payload);
    case 'updateAssignee':
      return state.set('assignee', action.payload);
  }

  return state;
}
